import { render, staticRenderFns } from "./button-group-two.mpx?vue&type=template&id=28bed963&isComponent&outputPath=components%2Fbutton-group-two736a4d99%2Findex"
import script from "./button-group-two.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbutton-group-two736a4d99%2Findex"
export * from "./button-group-two.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbutton-group-two736a4d99%2Findex"
import style0 from "./button-group-two.mpx?vue&type=style&index=0&id=28bed963&prod&lang=stylus&mpxStyleOptions=%7B%22scoped%22%3Atrue%2C%22mid%22%3A%22_736a4d99%22%7D&isComponent&outputPath=components%2Fbutton-group-two736a4d99%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports